var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 21 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 22.37c-3.342 1.048-7.7 4.902-10.07 8.63h-1.86C7.7 27.314 3.3 23.71 0 22.622v-4.44c3.342 1.256 6.938 4.23 8.97 6.744V0h3.891v25.051c1.989-2.597 5.67-5.864 9.139-7.121v4.44Z"
  })));
};
export default SvgArrowDown;